import moment from "moment";

export const adjustEditCustomerData = (payload, profileId, userId) => {
  let newData = {
    user_id: userId,
    profile_id: profileId
  };

  if (payload.bankAccount && payload.bankAccount.length !== 0) {
    newData["bank_account"] = payload.bankAccount.map(item => ({
      bank_name: payload[`bankName${item}`],
      bik: payload[`bik${item}`],
      account_corr: payload[`accountCorr${item}`],
      bank_account_num: payload[`bankAccountNum${item}`],
      bank_account_id: payload[`bankAccountId${item}`]
    }));
  } else {
    newData["bankAccount"] = null;
  }

  if (payload.subjectId) {
    newData["subject_id"] = payload.subjectId;
  }

  if (payload.subjectKey) {
    newData["subject_key"] = payload.subjectKey;
  }

  if (payload.phone) {
    newData["phone"] = payload.phone;
  }
  if (payload.phoneCode) {
    newData["phone_code"] = payload.phoneCode;
  }
  if (payload.subjectId) {
    newData["subject_id"] = payload.subjectId;
  }
  if (payload.profileId) {
    newData["profile_id"] = payload.profileId;
  }
  if (payload.companyId) {
    newData["company_id"] = payload.companyId;
  }
  if (payload.nameLegal) {
    newData["name_legal"] = payload.nameLegal;
  }
  if (payload.addressLegal) {
    newData["address_legal"] = payload.addressLegal;
  }
  if (payload.registrationDate) {
    newData["registraton_date"] = moment(payload.registratonDate).format("YYYY-MM-DD");
  }
  if (payload.inn) {
    newData["inn"] = payload.inn;
  }
  if (payload.kpp) {
    newData["kpp"] = payload.kpp;
  }
  if (payload.ogrn) {
    newData["ogrn"] = payload.ogrn;
  }
  if (payload.email) {
    newData["email"] = payload.email;
  }
  if (payload.name) {
    newData["name"] = payload.name;
  }
  if (payload.eio) {
    newData["eio"] = payload.eio;
  }
  if (payload.site) {
    newData["site"] = payload.site;
  }
  if (payload.lastname) {
    newData["lastname"] = payload.lastname;
  }
  if (payload.patronymic) {
    newData["patronymic"] = payload.patronymic;
  }

  if (payload.birthDate) {
    newData["birth_date"] = payload.birthDate.format("YYYY-MM-DD");
  }
  if (payload.passportSeries) {
    newData["passport_series"] = payload.passportSeries;
  }
  if (payload.passportNumber) {
    newData["passport_number"] = payload.passportNumber;
  }
  return newData;
};
